module.exports = __webpack_public_path__ + "img/monstars-4.471052c7.jpg";